import React from 'react'
import { useTranslation } from 'react-i18next'
import Loading from '../Loading'

export default function AnalyticsLoadingOverlay() {
    const { t } = useTranslation()
    return (
        <div role="status" aria-label={t('Loading...')} className="absolute inset-0 flex items-center justify-center">
            <Loading size={50} stroke={5} secondaryColor="white" primaryColor="#7C82C3" />
        </div>
    )
}
